export default __webpack_public_path__ + "static/media/CodePath.3fdb75dd.svg";